import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { OivCoreSharedFacade } from '@mobi/oiv-viewer-utils-ng-jslib';

import { NavigationFacade } from '../../data/navigation-facade';
import { SidenavComponent } from '../../ui/sidenav/sidenav.component';

@Component({
    selector: 'oiv-viewer-navigation',
    templateUrl: 'navigation.component.html',
    imports: [SidenavComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
    protected navigationFacade = inject(NavigationFacade);
    #coreSharedFacade = inject(OivCoreSharedFacade);

    sidenavItems = this.navigationFacade.sidenav;

    closeOverlay() {
        this.#coreSharedFacade.closeOverlay();
    }
}
